import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=15e27336&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=15e27336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e27336",
  null
  
)

export default component.exports